
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, IPaintable, instanceOfIPaintable } from "../../../../../domain/document/items";
import { PaintStyle } from "../../../../../domain/drawing";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class PainterPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: IPaintable) => void) => void;

  get paintStyle(): PaintStyle {
    return instanceOfIPaintable(this.editingSource)
      ? this.editingSource.paintStyle
      : undefined;
  }

  set paintStyle(value: PaintStyle) {
    this.writeProperty(s => s.paintStyle = value);
  }
}
